// extracted by mini-css-extract-plugin
module.exports = {"Page":"Page_Page__z6m5H"};